import { Skeleton } from "@flixbus/honeycomb-react";
import * as React from "react";
import * as css from "./RideTableBodySkeleton.scss";

const RideTableBodySkeleton: React.FC = () => (
  <div className={css.wrapperDesktop}>
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
    <Skeleton extraClasses={css.skeletonDesktop} />
  </div>
);

export default RideTableBodySkeleton;
